import React from 'react';
import { AuroraBackground } from '../components/ui/aurora-background';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <AuroraBackground>
      <div className="min-h-[calc(100vh-16rem)] flex items-center justify-center px-4 relative z-10">
        <div className="bg-white/80 dark:bg-zinc-900/80 backdrop-blur-lg p-8 rounded-xl shadow-lg w-full max-w-4xl overflow-y-auto max-h-[80vh]">
          <div className="flex items-center justify-between mb-6">
            <Link to="/login" className="text-blue-600 hover:text-blue-800">← Back to Login</Link>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Privacy Policy</h2>
            <div className="w-[120px]"></div>
          </div>
          <div className="text-gray-600 dark:text-gray-300">
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">Last Updated: March 25, 2025</p>
            
            <p className="mb-4">At ICanPitch, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our AI-powered tools, services, and platform (collectively, the "Service"). By using the Service, you agree to this Privacy Policy.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">1. Information We Collect</h3>
            <p className="mb-2">We collect the following types of information:</p>
            <div className="ml-5 mb-4">
              <p className="mb-2"><strong>Personal Information:</strong> Data you provide, such as your name, email address, or payment details when you sign up or contact us.</p>
              <p className="mb-2"><strong>User Content:</strong> Data or content you input into the Service (e.g., text, files, or prompts used with our AI tools).</p>
              <p className="mb-2"><strong>Usage Data:</strong> Information about how you interact with the Service, such as IP address, device type, browser, and activity logs.</p>
            </div>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">2. How We Use Your Information</h3>
            <p className="mb-2">We use your information to:</p>
            <div className="ml-5 mb-4">
              <p className="mb-2">Provide, maintain, and improve the Service.</p>
              <p className="mb-2">Train and enhance our AI models (using anonymized or aggregated data where possible).</p>
              <p className="mb-2">Respond to your inquiries or provide customer support.</p>
              <p className="mb-2">Analyze usage trends and optimize performance.</p>
              <p className="mb-2">Comply with legal obligations or protect our rights.</p>
            </div>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">3. Data Sharing</h3>
            <p className="mb-2">We may share your information with:</p>
            <div className="ml-5 mb-4">
              <p className="mb-2"><strong>Service Providers:</strong> Third parties that help us operate the Service (e.g., hosting, analytics, or payment processors), bound by confidentiality agreements.</p>
              <p className="mb-2"><strong>Legal Authorities:</strong> When required by law or to protect ICanPitch, our users, or the public.</p>
            </div>
            <p className="mb-4">We do not sell your personal information to third parties.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">4. AI Training</h3>
            <p className="mb-4">Data you input into the Service may be used to train our AI models. We strive to anonymize or aggregate this data to minimize privacy risks, but some inputs may be retained in their original form to improve functionality.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">5. Data Security</h3>
            <p className="mb-4">We use industry-standard encryption and security measures to protect your information. However, no system is entirely secure, and we cannot guarantee absolute protection against unauthorized access.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">6. Your Rights</h3>
            <p className="mb-2">Depending on your location, you may have rights to:</p>
            <div className="ml-5 mb-4">
              <p className="mb-2">Access, correct, or delete your personal information.</p>
              <p className="mb-2">Opt out of certain data uses (where applicable).</p>
            </div>
            <p className="mb-4">To exercise these rights, contact us at support@icanpitch.com. We'll respond within a reasonable timeframe, subject to legal requirements.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">7. Cookies and Tracking</h3>
            <p className="mb-4">We use cookies and similar technologies to enhance your experience and analyze usage. You can manage cookie preferences through your browser settings.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">8. Changes to This Policy</h3>
            <p className="mb-4">We may update this Privacy Policy as needed. We'll notify you of significant changes via email or through the Service. Your continued use of the Service after updates signifies your acceptance.</p>
            
            <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-900 dark:text-white">9. Contact Us</h3>
            <p className="mb-4">For privacy-related questions, reach out to:</p>
            <p className="mb-4">Email: support@icanpitch.com</p>
          </div>
        </div>
      </div>
    </AuroraBackground>
  );
};

export default PrivacyPolicy; 